export const tableFiltersStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    mb: 2,
  },

  filterControl: {
    minWidth: '150px',
    '& .MuiOutlinedInput-root': {
      height: '40px',
    },
  },

  clearButton: {
    height: '40px',
  },
};
